const banner = {
  alert: {
    backgroundColor: 'red.50'
  },
  notice: {
    backgroundColor: 'green.20'
  },
  warning: {
    backgroundColor: 'yellow.10'
  },
  white: {
    backgroundColor: 'white'
  }
};

export type AlertVariantsType = 'alert' | 'notice' | 'warning' | 'white';
export const alertVariants = Object.keys(banner) as AlertVariantsType[];

export default banner;
